import image1 from "../../assets/banner-10.jpg";
import image2 from "../../assets/banner-11.jpg";
import image3 from "../../assets/banner-12.jpg";
import image4 from "../../assets/banner-13.jpg";
import image5 from "../../assets/banner-14.jpg";

export const HOTDEAL = [
  {
    image: image4,
    btn: "Shop Now",
    className: "flex1",
  },
  {
    image: image5,
    btn: "Shop Now",
    className: "flex1",
  },
  {
    image: image3,
    btn: "Shop Now",
    className: "flex1",
  },
  {
    image: image1,
    btn: "Shop Now",
    className: "flex2",
  },
  {
    image: image2,
    btn: "Shop Now",
    className: "flex2",
  },
];
